// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workflow-editor-dev-info-panel .components-panel__row {
    overflow: scroll;
}

.workflow-editor-dev-info-wrapper {
    min-width: 1000px;
}

.workflow-editor-dev-panel {
    background-color: #fffaf1;
}
`, "",{"version":3,"sources":["webpack://./assets/jsx/workflow-editor/css/dev.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".workflow-editor-dev-info-panel .components-panel__row {\n    overflow: scroll;\n}\n\n.workflow-editor-dev-info-wrapper {\n    min-width: 1000px;\n}\n\n.workflow-editor-dev-panel {\n    background-color: #fffaf1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
